// Copyright (c) Facebook, Inc. and its affiliates.
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
      secondary: {
        light: '#fe7700',
        main: '#fe7700',
        dark: '#fe7700',
        contrastText: '#000',
      },
      primary: {
        light: '#fe7700',
        main: '#fe7700',
        dark: '#fe7700',
        contrastText: '#fff',
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: "Merriweather Sans, serif"
    },
});
export default theme;
